import { render, staticRenderFns } from "./Hozl3.vue?vue&type=template&id=72d2c656&"
import script from "./Hozl3.vue?vue&type=script&lang=js&"
export * from "./Hozl3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports